import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDk4MWOZ3y7BHVUvcMyh3RWxauKs_KGjdU",
  authDomain: "church-service-management.firebaseapp.com",
  projectId: "church-service-management",
  storageBucket: "church-service-management.firebasestorage.app",
  messagingSenderId: "7001274931",
  appId: "1:7001274931:web:604faaf7faf897f2830146",
  measurementId: "G-NXQPTYX2W7"
};

const app = initializeApp(firebaseConfig);
const firestoreDb = getFirestore(app);
const firebaseAuth = getAuth(app);

let messagingInstance = null;
try {
  messagingInstance = getMessaging(app);
} catch (e) {
  console.warn('Firebase messaging not supported in this browser');
}

export { app, firestoreDb, firebaseAuth, messagingInstance, getToken, onMessage };
